document.addEventListener(
  'click',
  function (e) {
    var btn = e.target.closest('[data-card-swatches] .card-swatch');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.card-wrapper, .product-card-wrapper, .card');
    if (!card) return;

    var img = card.querySelector('[data-card-main-image]');
    var src = btn.getAttribute('data-image-src');

    if (img && src) {
      img.src = src;
      img.removeAttribute('srcset');
    }

    var group = btn.closest('[data-card-swatches]');
    if (!group) return;

    group.querySelectorAll('.card-swatch').forEach(function (el) {
      el.classList.remove('is-active');
    });

    btn.classList.add('is-active');
  },
  true
);